import type { DriveSmartReading } from '../bench/drive-smart-display.js';

/**
 * The nine drive SMART measurements as a label / value table. Shared by the customer and ops portals (run detail, asset record).
 * Display only: values and units, no limits and no pass/fail. A value the drive did not report reads "Not reported", never 0.
 */
export function DriveSmartTable({ readings, testId = 'drive-smart' }: { readings: readonly DriveSmartReading[]; testId?: string }) {
  return (
    <table className="w-full text-sm" data-testid={testId}>
      <tbody>
        {readings.map((r) => (
          <tr key={r.name} className="border-t border-border first:border-t-0">
            <th scope="row" className="py-1 pr-4 text-left font-normal text-muted-foreground">
              {r.label}
            </th>
            <td className="py-1 font-mono" data-testid={`${testId}-${r.name}`}>
              {r.value === null ? (
                <span className="font-sans text-muted-foreground">Not reported</span>
              ) : r.unit === 'count' ? (
                r.value
              ) : (
                `${r.value} ${r.unit}`
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
